import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    BarChartSignLegendDynamicStyleType
} from "./type";
import type {
    Mutable
} from "../../../../types";

const stylesheet = StyleSheet.create({
    container: {
        alignItems: "center",
        flexDirection: "row",
        flexWrap: "wrap"
    },
    item: {
        alignItems: "center",
        flexDirection: "row"
    }
});

export const useStyles = ({
    spaces
}: BarChartSignLegendDynamicStyleType) => {
    const styles = {
        container: {
            columnGap: spaces.spacingMd,
            marginTop: spaces.spacingSm,
            rowGap: spaces.spacingXs
        } as Mutable<ViewStyle>,
        item: {
            gap: spaces.spacingSm
        } as Mutable<ViewStyle>
    };

    return styles;
};
export default stylesheet;
